// Маршруты (UI-UX 5): родительская оболочка с вкладками и полноэкранные маршруты (плеер, задание, детский режим).
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from "react-router";
import { KidMode } from "./kid/KidMode.tsx";
import { Shell } from "./components/Shell.tsx";
import { Article, Guide } from "./parent/Guide.tsx";
import { Catalog, CourseScreen } from "./parent/Catalog.tsx";
import { ExerciseScreen } from "./parent/Exercise.tsx";
import { Onboarding } from "./parent/Onboarding.tsx";
import { Player } from "./parent/Player.tsx";
import { Progress } from "./parent/Progress.tsx";
import { QuizScreen } from "./parent/QuizScreen.tsx";
import { Settings } from "./parent/Settings.tsx";
import { Today } from "./parent/Today.tsx";
import { activeChild, useApp } from "./state/app.ts";
import { t } from "./i18n/ru.ts";

function KidRoute() {
  const nav = useNavigate();
  const { content, settings } = useApp();
  const child = activeChild();
  if (!child) return <Navigate to="/welcome" replace />;
  if (!content) return <p className="page">{t.today.noContent}</p>;
  return <KidMode content={content} child={child} limitMin={settings.sessionLimitMin} holdSec={settings.lockHoldSec} onExit={() => nav("/today", { replace: true })} />;
}

function Guarded({ children }: { children: React.ReactNode }) {
  const onboarded = useApp((s) => s.onboarded);
  return onboarded ? <>{children}</> : <Navigate to="/welcome" replace />;
}

export function App() {
  const booted = useApp((s) => s.booted);
  if (!booted) return <div className="splash" aria-busy="true" />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/welcome" element={<Onboarding />} />
        <Route
          element={
            <Guarded>
              <Shell />
            </Guarded>
          }
        >
          <Route path="/today" element={<Today />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/course/:id" element={<CourseScreen />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/guide/:id" element={<Article />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/exercise/:id" element={<ExerciseScreen />} />
        </Route>
        <Route path="/scenario/:id" element={<Guarded><Player /></Guarded>} />
        <Route path="/scenario/:id/quiz/:quizId" element={<Guarded><QuizScreen /></Guarded>} />
        <Route path="/kid" element={<Guarded><KidRoute /></Guarded>} />
        <Route path="*" element={<Navigate to="/today" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
